import { render, staticRenderFns } from "./why-choose-stylool.vue?vue&type=template&id=0c9a5104&scoped=true"
import script from "./why-choose-stylool.vue?vue&type=script&lang=js"
export * from "./why-choose-stylool.vue?vue&type=script&lang=js"
import style0 from "./why-choose-stylool.vue?vue&type=style&index=0&id=0c9a5104&prod&lang=scss&scoped=true"
import style1 from "./why-choose-stylool.vue?vue&type=style&index=1&id=0c9a5104&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9a5104",
  null
  
)

export default component.exports